<template>
    <div class="laboratory-page">
        <!-- 工具条：说明 + 环境标识 -->
        <div class="lab-toolbar">
            <div class="lab-toolbar__info">
                <span class="lab-toolbar__icon">
                    <el-icon>
                        <Pear />
                    </el-icon>
                </span>
                <span class="lab-toolbar__meta">
                    <span class="lab-toolbar__title">实验室</span>
                    <span class="lab-toolbar__subtitle">仅在本机（localhost）环境可见的临时实验区，用于接口联调与本地缓存验证</span>
                </span>
            </div>
            <div class="lab-toolbar__actions">
                <el-tag class="lab-env-tag" type="warning" effect="plain">localhost</el-tag>
            </div>
        </div>

        <!-- 服务端接口 -->
        <el-card class="panel-card" shadow="never">
            <template #header>
                <div class="panel-card__head">
                    <span class="panel-card__title">服务端接口</span>
                    <span class="lab-hint">执行结果输出到浏览器控制台</span>
                </div>
            </template>

            <div class="lab-item">
                <div class="lab-item__meta">
                    <span class="lab-item__name">导出文件列表</span>
                    <span class="lab-item__desc">GET /test/export，导出服务端文件清单</span>
                </div>
                <el-button class="lab-btn" @click="exportFileList">
                    <el-icon class="lab-btn__icon">
                        <Download />
                    </el-icon>
                    执行
                </el-button>
            </div>
        </el-card>

        <!-- 大对象与本地缓存 -->
        <el-card class="panel-card" shadow="never">
            <template #header>
                <div class="panel-card__head">
                    <span class="panel-card__title">大对象缓存</span>
                    <span class="lab-hint">数据写入浏览器 IndexedDB（库 temp、表 SysAccessLog）</span>
                </div>
            </template>

            <div class="lab-item">
                <div class="lab-item__meta">
                    <span class="lab-item__name">大对象加载</span>
                    <span class="lab-item__desc">GET /test/loadbig，拉取大对象并批量写入 IndexedDB</span>
                </div>
                <el-button class="lab-btn" @click="loadBigObject">
                    <el-icon class="lab-btn__icon">
                        <Upload />
                    </el-icon>
                    执行
                </el-button>
            </div>

            <div class="lab-item">
                <div class="lab-item__meta">
                    <span class="lab-item__name">读取 IndexedDB 缓存</span>
                    <span class="lab-item__desc">按索引（ip + method）游标遍历已写入的 SysAccessLog 记录</span>
                </div>
                <el-button class="lab-btn" @click="loadIndexedDbData">
                    <el-icon class="lab-btn__icon">
                        <View />
                    </el-icon>
                    执行
                </el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';

export default {
    methods: {
        exportFileList() {
            request({
                url: '/test/export',
                method: 'get'
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    ElMessage.success('导出完成，结果见控制台');
                }
            });
        },
        loadBigObject() {
            request({
                url: '/test/loadbig',
                method: 'get'
            }).then(res => {
                if (res.code != 0) {
                    return;
                }
                console.log(res);

                var openRequest = window.indexedDB.open('temp', 1);
                var db;

                openRequest.onerror = function () {
                    console.log('数据库打开报错');
                    ElMessage.error('IndexedDB 打开失败');
                };

                openRequest.onsuccess = function () {
                    db = openRequest.result;
                    console.log('数据库打开成功');

                    var list = res.data || [];
                    var objectStore = db.transaction(['SysAccessLog'], 'readwrite').objectStore('SysAccessLog');
                    for (let i = 0; i < list.length; i++) {
                        objectStore.add(list[i]);
                    }
                    ElMessage.success('已写入 ' + list.length + ' 条记录');
                };

                openRequest.onupgradeneeded = function (event) {
                    db = event.target.result;
                    if (!db.objectStoreNames.contains('SysAccessLog')) {
                        var objectStore = db.createObjectStore('SysAccessLog', { keyPath: 'id' });
                        objectStore.createIndex('myindex', ['ip', 'method'], { unique: false });
                    }
                    console.log('数据表创建成功');
                };
            });
        },
        loadIndexedDbData() {
            var openRequest = window.indexedDB.open('temp', 1);
            var db;

            // 打开错误回调
            openRequest.onerror = function () {
                console.log('数据库打开报错');
                ElMessage.error('IndexedDB 打开失败');
            };

            // 打开成功回调
            openRequest.onsuccess = function () {
                db = openRequest.result;
                console.log('数据库打开成功');

                // 按索引（ip + method）游标遍历数据
                var objectStore = db.transaction(['SysAccessLog']).objectStore('SysAccessLog');
                var index = objectStore.index('myindex');
                var cursorRequest = index.openCursor(IDBKeyRange.only(['10.16.12.106', 'GET']));

                var count = 0;

                // 查询错误回调
                cursorRequest.onerror = function () {
                    console.log('事务失败');
                    ElMessage.error('IndexedDB 查询失败');
                };

                // 查询成功回调（游标循环处理）
                cursorRequest.onsuccess = function (event) {
                    var cursor = event.target.result;
                    if (cursor) {
                        console.log(cursor.key + ':' + JSON.stringify(cursor.value));
                        count += 1;
                        cursor.continue();
                    } else {
                        ElMessage.success('读取到 ' + count + ' 条记录，详情见控制台');
                    }
                };
            };

            // 数据库升级回调
            openRequest.onupgradeneeded = function (event) {
                db = event.target.result;
            };
        }
    }
};
</script>

<style scoped>
.laboratory-page {
    /* 局部覆盖主色，与其它工作台页面保持同一套视觉语言 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --lab-text: #1f2d3d;
    --lab-muted: #aab4c4;
    --lab-line: #eef1f6;
    --lab-border: #e6eaf0;

    color: var(--lab-text);
}

/* ---------- 工具条 ---------- */
.lab-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    row-gap: 10px;
    padding: 10px 16px;
    border: 1px solid #ebeef5;
    border-radius: 12px;
    background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
    box-shadow: 0 10px 28px -22px rgba(31, 45, 61, 0.55);
}

.lab-toolbar__info {
    display: flex;
    align-items: center;
    min-width: 0;
}

.lab-toolbar__icon {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin-right: 10px;
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    background: linear-gradient(135deg, #6a9cff 0%, #2f6fed 100%);
    box-shadow: 0 8px 16px -10px rgba(47, 111, 237, 0.9);
}

.lab-toolbar__meta {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.lab-toolbar__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: var(--lab-text);
}

.lab-toolbar__subtitle {
    font-size: 12px;
    line-height: 16px;
    color: #a8abb2;
}

.lab-toolbar__actions {
    display: flex;
    flex: none;
    align-items: center;
}

.lab-env-tag {
    border-radius: 999px;
}

/* ---------- 面板卡 ---------- */
.laboratory-page .panel-card {
    margin: 12px 0 0;
    border: 1px solid var(--lab-border);
    border-radius: 12px;
}
.laboratory-page .panel-card :deep(.el-card__header) {
    padding: 14px 18px;
    border-bottom: 1px solid var(--lab-line);
}
.laboratory-page .panel-card :deep(.el-card__body) {
    padding: 6px 18px 10px;
}

.panel-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.panel-card__title {
    position: relative;
    padding-left: 10px;
    font-size: 15px;
    font-weight: 600;
}
.panel-card__title::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 3px;
    height: 14px;
    margin-top: -7px;
    border-radius: 2px;
    background: linear-gradient(180deg, #6a9cff, #3f6fff);
}

.lab-hint {
    font-size: 12px;
    color: var(--lab-muted);
}

/* ---------- 实验项 ---------- */
.lab-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 0;
}
.lab-item + .lab-item {
    border-top: 1px dashed var(--lab-line);
}

.lab-item__meta {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.lab-item__name {
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
}

.lab-item__desc {
    font-size: 12px;
    line-height: 18px;
    color: var(--lab-muted);
}

/* ---------- 执行按钮 ---------- */
.lab-btn.el-button {
    flex: none;
    height: 34px;
    padding: 0 16px;
    border-radius: 9px;
    font-weight: 500;
    color: #606266;
    background-color: #fff;
    border-color: #e4e7ed;
    transition: all 0.2s ease;
}
.lab-btn.el-button:hover,
.lab-btn.el-button:focus {
    color: var(--el-color-primary);
    background-color: var(--el-color-primary-light-9);
    border-color: var(--el-color-primary-light-5);
    transform: translateY(-1px);
    box-shadow: 0 10px 18px -12px rgba(47, 111, 237, 0.9);
}
.lab-btn__icon {
    margin-right: 4px;
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 700px) {
    .lab-toolbar {
        padding: 10px 12px;
    }
    .panel-card__head {
        flex-wrap: wrap;
    }
    .laboratory-page .panel-card :deep(.el-card__header) {
        padding: 12px 14px;
    }
    .laboratory-page .panel-card :deep(.el-card__body) {
        padding: 4px 14px 8px;
    }
    .lab-item {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }
    .lab-btn.el-button {
        width: 100%;
    }
}
</style>
